import { render } from "./404.vue?vue&type=template&id=25e18893&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=25e18893&scoped=true&lang=less"

import exportComponent from "D:\\_A-Project\\KoManga\\Ko-Manga-Center-Ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e18893"]])

export default __exports__